import React from "react";
import './ _format-filter-tile.scss';

const baseClass = 'format-filter-tile';

interface PropTypes {
  formatLogo: string;
  formatLabel: string;
  formatDescription: string;
  formatTags: any
  handleFormatFilter?: any
  setSelectedFormat?: any
  selectedFormat?: any,
  formatTagsDisplay: any
  selectedFormatFilterName: any
}

const FormatFilterTile = (props: PropTypes): JSX.Element => {
  const formatTagsDisplay = props.formatTagsDisplay.map((formatText: any, index: number) =>
      <div className={'format-text'} key={index}>
        {formatText}
      </div>
  );

  const isFormatSelected = props.selectedFormatFilterName && props.formatLabel? !!props.selectedFormatFilterName.includes(props.formatLabel) : false;
  return (
    <div className={`${baseClass} ${isFormatSelected ? 'selected' : ''}`} onClick={() => props.setSelectedFormat(props.formatTags, props.formatLabel)}>
      <div className={`${baseClass}--tile-details-wrapper`}>
        {props.formatLogo && (
          <div className={`${baseClass}--format-logo-container`}>
            {props.formatLogo  && (
              <img src={props.formatLogo} className={`format-logo`} alt="logo"/>
            )}
          </div>
        )}
        <div className={`${baseClass}--content`}>
          {props.formatLabel && (
            <div className={`format-label`}>{props.formatLabel}</div>
          )}
          {props.formatDescription && (
            <div
              className={`format-description`}>{props.formatDescription}</div>
          )}
        </div>
      </div>
      <div className={'formats-container'} >
        {formatTagsDisplay}
      </div>
    </div>
  )
}

export default FormatFilterTile;
